/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';

import { upgradeReasons } from '@zapier/upsells/src/types';
import { LogoImage } from './LogoImage';

// Used to fine-tune the sizing and positioning of individual images.
const imageCss = (type: string) => {
  const dimensions = {
    [upgradeReasons.emailSupport]: {},
    [upgradeReasons.multistep]: {},
    [upgradeReasons.paths]: {
      height: '84%',
    },
    [upgradeReasons.premium]: {
      left: '-90px',
      position: 'absolute' as 'absolute',
    },
    [upgradeReasons.premiumLimit]: {
      left: '-145px',
      position: 'absolute' as 'absolute',
      width: '555px',
    },
    [upgradeReasons.taskLimit]: {
      height: '60%',
    },
    [upgradeReasons.taskLimitLow]: {
      height: '95%',
    },
    'tasks-low-50-percent': {
      height: '95%',
    },
    [upgradeReasons.zapLimit]: {},
  };

  return css({
    svg: {
      height: '100%',
      ...dimensions[type],
    },
  });
};

const imageContainerCss = css`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
`;

type Props = {
  appName?: string;
  type: string; // Can be changed to UpgradeReason type after the low task experiment is removed.
};

const imageMap = {
  [upgradeReasons.emailSupport]: 'UpgradeNudgeEmailSupport',
  [upgradeReasons.multistep]: 'UpgradeNudgeMultistep',
  [upgradeReasons.paths]: 'UpgradeNudgePaths',
  [upgradeReasons.premium]: 'UpgradeNudgeApps',
  [upgradeReasons.premiumLimit]: 'UpgradeNudgeApps',
  [upgradeReasons.taskLimit]: 'UpgradeNudgeTaskLimit',
  [upgradeReasons.taskLimitLow]: 'UpgradeNudgeTaskLimitLow',
  [upgradeReasons.zapLimit]: 'UpgradeNudgeZaps',
  /**
   * This is a temporary special case for an experiment and isn't a separate upgrade reason. That's why
   * it's not added to `upgradeReasons`.
   */
  'tasks-low-50-percent': 'UpgradeNudgeTaskLimitLow50Percent',
};

export const NudgeImage = ({ type, appName }: Props) => {
  const fileName = imageMap[type];
  let ImageSvg;

  try {
    ImageSvg = require(`./images/${fileName}`).default;
  } catch {
    ImageSvg = null;
  }

  return ImageSvg ? (
    <div css={[imageContainerCss, imageCss(type)]}>
      <ImageSvg />
      {appName && <LogoImage app={appName} />}
    </div>
  ) : null;
};
